<template>
    <div class="content-wrapper">

    <div class="row">
    <div class="col-sm-12 col-md-6">
    <nav aria-label="breadcrumb">
    <ol class="breadcrumb p-0 d-flex align-items-center">
    <li class="breadcrumb-item page-header d-flex align-items-center">
    <h4 class="mb-0">{{ $t('password_manager') }}</h4>
    </li>
    </ol>
    </nav>
    </div>
    <div class="col-sm-12 col-md-6">
    <div class="text-sm-right mb-sm-0 mb-md-0">
    
                <button type="button" class="btn btn-success btn-with-shadow mb-4" @click="openGeneratePasswordModal">
                    <app-icon name="plus" class="size-20 mr-2"/>
                    {{ $t('generate_password') }}
                </button>
                <button type="button" v-if="$can('create_password_manager')"
                        class="btn btn-primary btn-with-shadow mb-4"
                        @click="openModal">
                    <app-icon name="plus" class="size-20 mr-2"/>
                    {{ $t('add_password_manager') }}
                </button>
    </div>
    </div>
    </div>



        <app-table :id="tableId" :options="options" @action="getListAction"/>

        <!-- Password Manager Add/Edit Modal -->
        <password-manager-add-edit-modal
            v-if="isModalActive"
            :table-id="tableId"
            :selected-url="selectUrl"
            @closeModal="closeModal"
        />

        <!-- Client Delete Modal -->
        <app-delete-modal
            v-if="confirmationModalActive"
            modal-id="delete-confirm-modal"
            :message="$t('are_you_sure_to_delete_this_category')"
            @confirmed="confirmDelete"
            @cancelled="cancelledDelete"
        />

        <app-modal v-if="generatePasswordModalActive" modal-alignment="top" modal-id="generate-password-modal" modal-size="default" @close-modal="closeGeneratePasswordModal">
            <template slot="header">
                <h5 class="modal-title">{{ $t('generate_password') }}</h5>
                <button aria-label="Close" class="close outline-none" data-dismiss="modal" type="button">
                    <span>
                        <app-icon :name="'x'"></app-icon>
                    </span>
                </button>
            </template>
            <template slot="body">


    			
            <div class="row">
                <div class="col-md-12 mb-3">
                    <div class="form-group">
                        <label for="passwordHint">
                            {{ $t('password_hints') }}
                        </label>
                        <app-input
                            id="passwordHint"
                            type="text"
                            :placeholder="$t('enter_password_hints')"
                            @keyup="generatedPasswordHints"
                            v-model="formData.password_hints"
                            :error-message="$errorMessage(errors, 'password_hints')"
                        />
                    </div>
                </div>
                <div class="col-md-12 mb-3">
                    <div class="my-3">
                        <div class="d-flex align-items-center justify-content-center">
                        <div class="mr-2">
                        Generated Password Key is: 
                        </div>
                        <span class="badge badge-pill badge-primary text-capitalize" v-if="generated_key">{{ generated_key }}</span>
                        </div>
                    </div>
                </div>
                
            </div>
            
            </template>
            <template slot="footer">
                <button
                    class="btn btn-secondary mr-2"
                    data-dismiss="modal"
                    type="button"
                    @click.prevent="closeGeneratePasswordModal">
                    {{ $t('close') }}
                </button>
            </template>
        </app-modal>



    </div>
</template>

<script>
import PasswordManagerTableMixin from '../../../Mixins/PasswordManagerTableMixin';

export default {
    name: 'Index',
    mixins: [PasswordManagerTableMixin],
    data() {
        return {
            formData: { password_hints: '' },
            generated_key:'',
            errors:{},
        }
    },
    methods: {
        generatedPasswordHints() {

            let sum = 0;
            const number = 55555;
            let password_hints = this.formData.password_hints.toLowerCase().replace(/[^a-zA-Z0-9! ]+/g, "");
            const letterArray = password_hints.split("");

            letterArray.forEach(function (item, index) {

                sum += item.charCodeAt(0) + number;

            });

            this.generated_key=sum.toString().substring(0,6);
            
        }
    }
}
</script>